import React from 'react';
import {ActionIcon, Tooltip} from '@mantine/core';
import {IconCalendar, IconCurrencyEuro, IconMessage} from '@tabler/icons-react';
import {useTranslation} from 'react-i18next';
import {AccountService} from '@bobex/react-core/services/AccountService';
import {RouteUtils} from '@bobex/react-core/routes/RouteUtils';
import {ColorSchemeToggle} from '@bobex/react-core/components/ColorSchemeToggle/ColorSchemeToggle';
import {LanguagePicker} from '@bobex/react-core/components/LanguagePicker/LanguagePicker';

/** Secondary actions: shown in the top bar on >= sm, inside the navigation drawer below that. */
export default function QuickActions() {
  const { t } = useTranslation();
  const user = AccountService.getUser();

  return (
    <>
      <ColorSchemeToggle />
      <LanguagePicker />
      <ActionIcon variant="default" size="lg" aria-label="Unpaid clients">
        <IconCurrencyEuro stroke={1.5} />
      </ActionIcon>
      <Tooltip label={t('Calendar')}>
        <ActionIcon
          variant="default"
          size="lg"
          aria-label="Calendar"
          component="a"
          href={
            user?.userID
              ? `${RouteUtils.getBackofficeServletBasename()}/todo_calendar_call?userid=${user.userID}`
              : '#'
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          <IconCalendar stroke={1.5} />
        </ActionIcon>
      </Tooltip>
      <ActionIcon variant="default" size="lg" aria-label="Messages">
        <IconMessage stroke={1.5} />
      </ActionIcon>
    </>
  );
}
